import normalize from 'json-api-normalizer';

export default class ModerationAction {
	static from (jsonapi) {
		let key = 'moderationAction'
		let normalizedJSONapi = normalize(jsonapi);
		if (!(Object.keys(normalizedJSONapi).includes(key))) return null;

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = ModerationAction.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return ModerationAction.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi, noRelationships=0) {
		const { id, attributes } = jsonapi;

		return new ModerationAction ( Object.assign({}, {id: id}, attributes) );
	}

	constructor ({ id, postId, userId, userComment , responderComment, responderId, createdAt }) {

		this.id             = id ? id : -1;
        this.post_id		= postId ? postId : -1;
        this.user_id		= userId ? userId : -1;
		this.user_comment           = userComment ? userComment : null;
		this.responder_comment   = responderComment ? responderComment : null;
        this.responder_id         = responderId ? responderId : null;
		this.created_at			= createdAt ? createdAt : null;
        	
	}

	toJSONapi () {

		let attributes = Object.assign({}, this);
		delete attributes.id;
		return { data: { type: "moderation_action", id: this.id, attributes: attributes } };
	}
}
